import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import DOMPurify from "dompurify";
import { FETCH_DATA_ESTATE_SUMMARY } from "../../DataTagConstants";
import "./DataEstateSummary.scss";

function DataEstateSummary() {
  const dispatch = useDispatch();

  const summaryData = useSelector(
    (state) => state.dataTagReducer.dataEstateSummary
  );

  const dataSourceId = useSelector(
    (state) => state.dataTagReducer.selectedDataSource?.id
  );

  useEffect(() => {
    if (dataSourceId) {
      dispatch({
        type: FETCH_DATA_ESTATE_SUMMARY,
        payload: { dataSourceId },
      });
    }
  }, [dataSourceId]);

  const highlightWords = [
    "highly",
    "high",
    "risk",
    "medium",
    "sensitivity",
    "sensitive",
    "publicly",
    "low",
    "public",
    "PCI",
    "PII",
    "GDPR",
    "Confidential",
    "Financial",
    "PHI/HIPAA",
  ];

  const processedHTML = useMemo(() => {
    const raw = summaryData?.text || "-";
    let updated = raw;

    highlightWords.forEach((word) => {
      const regex = new RegExp(`(${word})`, "gi");
      updated = updated.replace(regex, "<b>$1</b>");
    });

    return DOMPurify.sanitize(updated);
  }, [summaryData]);

  return (
    <div className="de-summary-container">
      <div className="de-summary-card">
        <p
          className="de-summary-text"
          dangerouslySetInnerHTML={{ __html: processedHTML }}
        />
      </div>
    </div>
  );
}

export default DataEstateSummary;
